import { Input } from 'antd';
import styled, { css } from 'styled-components';

export const TableStyle = css`
  .ant-table-tbody {
    .ant-table-cell {
      padding-bottom: 0px;
      padding-top: 12px;
    }
  }
  .ant-table-cell:has(.delete-icon) {
    padding-top: 0px;
  }
`;

export const TableLoadingStyle = css`
  .ant-table-cell {
    padding-top: 12px;
  }
  .ant-table-cell:has(.delete-icon) {
    padding-top: 0px;
  }
`;

export const CInput = styled(Input)<{
  width?: string;
  height?: string;
  background?: string;
  fontSize?: string;
  fontWeight?: string;
  styles?: any;
}>`
  width: ${p => p.width || '100%'};
  height: ${p => p.height || '48px'};
  background: ${p => p.background || '#fff'};
  font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};

  .ant-input {
    background: ${p => p.background || '#fff'};
    font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    font-weight: ${p => p.theme.font.weight[p.fontWeight || 'regular']};
    &::placeholder {
      font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    }
  }
  ${p => p.styles}
`;

export const Wrapper = styled.div`
  .ant-table-cell {
    padding-bottom: 0px !important;
  }
`;
